<template>
  <main role="main">

    <div class="block mb-3">
      <div class="row mr-0">
        <div class="col-md-8">
          <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators" id="news-carousel-indicators">
              <li data-target="#carouselExampleIndicators" v-for="(pic, index) in newsPictureList" :key="index" data-slide-to="0" v-bind:class="[index === 0 ? 'active' : '']"></li>
              <!-- <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
              <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
              <li data-target="#carouselExampleIndicators" data-slide-to="2"></li> -->
            </ol>
            <div class="carousel-inner" id="news-carousel">
              <div class="carousel-item" v-for="(pic, index) in newsPictureList" :key="pic" v-bind:class="[index === 0 ? 'active' : '']">
                <img class="d-block w-100" :src="pic" style="height: 300px">
              </div>
              <!-- <div class="carousel-item active">
                <img class="d-block w-100" src="img/pic1-c.jpg" style="height: 300px" alt="First slide">
              </div> -->
            </div>
            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>

        <div class="col-md-4">
          <div class="h-100">
            <div class="row h-50 d-flex flex-column">
              <div class="col-md-12 h-50 p-1">
                <button type="button" class="btn btn-login user w-100 h-100 d-flex flex-column justify-content-center align-items-center" @click="openSellerLogin">
                  <img class="img-fluid d-block mb-2" src="../assets/pfsdl.png" alt="">
                  <span>经销商登录</span>
                </button>
              </div>
            </div>

            <div class="row h-50 d-flex flex-column">
              <div class="col-md-12 h-50 p-1">
                <button type="button" class="btn btn-login gov w-100 h-100 d-flex flex-column justify-content-center align-items-center" @click="openGovLogin">
                  <img class="img-fluid d-block mb-2" src="../assets/jgdwdl.png" alt="">
                  <span>监管单位登录</span>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="row m-0 mb-3">
      <div class="col-md-8 block">
        <div class="block-header">
          <span class="block-header-text">时事新闻</span>
        </div>
        <div class="">
          <ul class="list-unstyled" id="news">
            <li class="d-flex justify-content-between news" v-for="news in newsList" :key="news.id">
              <a class="news-link text-nong text-truncate" href @click="goToNews(news.id, $event)">{{news.title}}</a>
              <span class="text-muted text-nowrap">[{{news.displayDate}}]</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-4 block">
        <div class="block-header">
          <span class="block-header-text">政务通知</span>
        </div>
        <ul class="list-unstyled" id="notification">
          <li class="d-flex justify-content-between news"  v-for="notification in notifications" :key="notification.id">
            <a class="news-link text-nong text-truncate" href @click="goToNews(notification.id, $event)">{{notification.title}}</a>
            <span class="text-muted text-nowrap">[{{notification.displayDate}}]</span>
          </li>
        </ul>

        <hr>

        <div class="row">
          <div class="col-md-3">
            <!-- <router-link to="#pesticide" class="btn btn-login-sm w-100 h-100 d-flex flex-column justify-content-between align-items-center">
              <img class="img-fluid d-block mb-1" src="../assets/sydw.png" alt="">
              <span>农药查询</span>
            </router-link> -->
            <a @click="scrollTo('pesticide', $event)" href class="btn btn-login-sm w-100 h-100 d-flex flex-column justify-content-between align-items-center">
              <img class="img-fluid d-block mb-1" src="../assets/sydw.png" alt="">
              <span>农药查询</span>
            </a>
          </div>
          <div class="col-md-3">
            <a @click="scrollTo('seller', $event)" href class="btn btn-login-sm w-100 h-100 d-flex flex-column justify-content-between align-items-center">
            <!-- <a href="#seller-list" class="btn btn-login-sm w-100 h-100 d-flex flex-column justify-content-between align-items-center" data-toggle="modal" data-target="#permitModal"> -->
              <img class="img-fluid d-block mb-1" src="../assets/djxx.png" alt="">
              <span>经营单位</span>
            </a>
          </div>
          <div class="col-md-3">
            <a id="zcsq" href="https://app.nongxiao123.com/#/gov/permit-register" target="_blank" class="btn btn-login-sm w-100 h-100 d-flex flex-column justify-content-between align-items-center">
              <img class="img-fluid d-block mb-1" src="../assets/zcsq.png" alt="">
              <span>申请经营许可证</span>
            </a>
            <!-- <a id="ssjs" href class="btn btn-login-sm w-100 h-100 d-flex flex-column justify-content-between align-items-center">
              <img class="img-fluid d-block mb-1" src="img/ssjs.png" alt="">
              <span>省所介绍</span>
            </a> -->
          </div>
          <div class="col-md-3 text-center">
            <a id="contact" :href="govWebsite" target="_blank" class="btn btn-login-sm w-100 h-100 d-flex flex-column justify-content-between align-items-center">
              <img class="img-fluid d-block mb-1" src="../assets/bszn.png" alt="">
              <span>联系我们</span>
            </a>
          </div>
        </div>

      </div>
    </div>

    <div class="block mb-3">
      <div class="block-header">
        <span class="block-header-text">优秀经销商展示</span>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div id="slider">
            <!-- Loading Screen -->
            <div data-u="loading" class="jssorl-009-spin">
              <img style="margin-top:-19px;position:relative;top:50%;width:38px;height:38px;" src="../assets/spin.svg" />
            </div>
            <div data-u="slides" class="jssor-slides" id="seller-examples">
              <div data-p="30.00" v-for="seller in selectedUserList" :key="seller">
                <a :href="seller" rel="group">
                  <img :data-u="seller" :src="seller" width="200" height="150"/>
                </a>
              </div>
              <!-- <div data-p="30.00">
                <a href="img/pic1.jpg" rel="group"><img data-u="image" src="img/pic1.jpg" /></a>
              </div>
              <div data-p="30.00">
                <a href="img/pic2.jpg" rel="group"><img data-u="image" src="img/pic2.jpg" /></a>
              </div>
              <div data-p="30.00">
                <a href="img/pic3.jpg" rel="group"><img data-u="image" src="img/pic3.jpg" /></a>
              </div> -->
              <!-- <div data-p="30.00">
                <a href="img/pic1.jpg" rel="group"><img data-u="image" src="img/pic1.jpg" /></a>
              </div>
              <div data-p="30.00">
                <a href="img/pic2.jpg" rel="group"><img data-u="image" src="img/pic2.jpg" /></a>
              </div>
              <div data-p="30.00">
                <a href="img/pic3.jpg" rel="group"><img data-u="image" src="img/pic3.jpg" /></a>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="block mb-3" ref="pesticide">
      <div class="block-header">
        <span class="block-header-text">备案农药查询</span>
      </div>
      <table id="table1" class="table table-bordered table-hover">
        <thead style="background: #EAF2F1;">
          <tr>
            <th scope="col">登记证号</th>
            <th scope="col">登记名称</th>
            <th scope="col">毒性</th>
            <th scope="col">生产厂家</th>
            <th scope="col">申报单位</th>
            <th scope="col">公示日期</th>
          </tr>
        </thead>
        <tbody class="text-nong">
        </tbody>
      </table>
    </div>

    <div class="block mb-3" ref="seller">
      <div class="block-header">
        <span class="block-header-text">农药经营单位公示</span>
      </div>
      <!-- <p class="block-header">农药经营单位公示</p> -->
      <table id="table2" class="table table-bordered table-hover">
        <thead style="background: #EAF2F1;">
          <tr>
            <th scope="col">单位名称</th>
            <th scope="col">负责人</th>
            <th scope="col">地址</th>
            <th scope="col">高毒定点</th>
            <th scope="col">公示日期</th>
          </tr>
        </thead>
        <tbody class="text-nong">
        </tbody>
      </table>
    </div>

  </main>
</template>

<script>
import axios from 'axios'
// import {config} from '../main'

// console.log('config', config)
// var BASE_URL = 'https://api.nongxiao123.com'
var BASE_URL = 'https://yz.api.nongxiao123.com'
// var UPLOAD_PREFIX = 'https://res.nongxiao123.com/'

var table1 = null
var table2 = null
// var govWebsite = null

var options = {
    // https://www.jssor.com/development/api-options.html
    $AutoPlay: 1,
    $Idle: 0,
    $SlideDuration: 5000,
    $SlideEasing: $Jease$.$Linear,
    $PauseOnHover: 4,
    $SlideWidth: 200,
    $SlideHeight: 150,
    // $Cols: 7,
    $Align: 0,
    // $FillMode: 2
    // $SlideSpacing: 4
  }
var jssor_slider = null

export default {
  name: 'HomePage',
  data: function () {
    return {
      info: null,
      newsList: [],
      notifications: [],
      newsPictureList: [],
      selectedUserList: [],
      govWebsite: ''
    }
  },
  computed: {
    url () {
      console.log('URL: ', this.$route.params.url)
      return this.$route.params.url
    }
  },
  methods: {
    init: function () {
      $.fn.DataTable.ext.pager.numbers_length = 5;
      $.extend(true, $.fn.dataTable.defaults, {
        "processing": true,
        "serverSide": true,
        // "searching": false,
        "ordering": false,
        // "dom": "<'row'<'col-sm-12'tr>>" +
        // "<'row'<'col-sm-2'l><'col-sm-5'><'col-sm-1'i><'col-sm-4'p>>",
        language: {
          "sProcessing": "<h3>处理中...</h3>",
          "sLengthMenu": "显示 _MENU_ 项结果",
          "sZeroRecords": "没有匹配结果",
          "sInfo": "第 _START_ 至 _END_ 项，共 _TOTAL_ 项",
          "sInfoEmpty": "显示第 0 至 0 项结果，共 0 项",
          "sInfoFiltered": "",
          // "sInfoFiltered": "(由 _MAX_ 项结果过滤)",
          "sInfoPostFix": "",
          "sSearch": "搜索:",
          "sUrl": "",
          "sEmptyTable": "表中数据为空",
          "sLoadingRecords": "载入中...",
          "sInfoThousands": ",",
          "oPaginate": {
            "sFirst": "首页",
            "sPrevious": "上页",
            "sNext": "下页",
            "sLast": "末页"
          },
          "oAria": {
            "sSortAscending": ": 以升序排列此列",
            "sSortDescending": ": 以降序排列此列"
          }
        }
      })
    },
    getInfo: function (url) {
      var that = this

      axios.get(this.$BASE_URL + '/common/govsite/list?url=' + url)
        .then(function (resp) {
          console.log('axios', resp.data.data)
          if (resp.data.data.length === 1) {
            console.log('Info', resp.data.data[0])
            that.info = resp.data.data[0]
            that.getData(resp.data.data[0])

            table1 = $('#table1').DataTable({
              "ajax": {
                // "url": that.$BASE_URL + '/web/product/gov/list' + that.getLocationUrl() + '&register=1',
                "url": that.$BASE_URL + '/web/product/gov/list' + that.getLocationUrl(),
              },
              // "data": function(d) {
              //   d.register = 1
              // },
              "columns": [
                {
                  "data": "djzh"
                },
                {
                  "data": "productName"
                },
                {
                  "data": "dx",
                  "searchable": false,
                  render: function(data, type, row) {
                    var str = ''
                    if (data && data.indexOf('高毒') !== -1) {
                      str = '<span class="text-danger">' + data + '</span>'
                    } else {
                      str = data
                    }
                    return str
                  }
                },
                {
                  "data": "brandName",
                  "searchable": false
                },
                {
                  "data": "supplyName",
                  "searchable": false
                },
                {
                  "data": "registerDate",
                  "searchable": false,
                  render: function(data, type, row) {
                    if (data) {
                      return that.formatTimestamp(data)
                    } else {
                      return 'N/A'
                    }
                  }
                }
              ]
            })

            table2 = $('#table2').DataTable({
              "ajax": {
                "url": that.$BASE_URL + '/web/user/gov/list' + that.getLocationUrl(),
              },
              "columns": [
                {
                  "data": "companyName"
                },
                {
                  "data": "userName"
                },
                {
                  "data": "address",
                  "searchable": false,
                  render: function(data, type, row) {
                    return (row.province || '') + (row.city || '') + (row.town || '') + (data || '')
                  }
                },
                {
                  "data": "special",
                  "searchable": false,
                  render: function(data) {
                    if (data) {
                      return '是'
                    } else {
                      return '否'
                    }
                  }
                },
                {
                  "data": "createTime",
                  "searchable": false,
                  render: function(data) {
                    return that.formatTimestamp(data)
                  }
                }
              ]
            })
          } else {
            console.log('Search error: ' + url, resp.data.data)
            that.$router.push({name: 'About'})
          }
        })
        .catch(function (error) {
          console.log('axios error', error)
        })
    },
    getData: function (info) {
      var that = this

      axios.get(this.$BASE_URL + '/common/news/gov', {
        params: {
          province: info.province,
          city: info.city,
          town: info.town
        }
      })
        .then(function (resp) {
          console.log('axios', resp.data.data)
          // var data = resp.data.data
          var newsList = resp.data.data.newsList.slice(0, 7)
            
          if (newsList.length === 0) {
            axios.get(that.$BASE_URL + '/common/news/gov/default')
            .then(function (resp) {
              console.log('axios default', resp.data.data)
              newsList = resp.data.data.newsList
              newsList.forEach(function(news) {
                news.displayDate = that.formatTimestamp(news.date)
              })
              that.newsList = newsList

              resp.data.data.noticeList.forEach(function(notification) {
                notification.displayDate = that.formatTimestamp(notification.date)
              })
              that.notifications = resp.data.data.noticeList

              that.newsPictureList = resp.data.data.newsPictureList

              that.selectedUserList = resp.data.data.selectedUserList

              window.setTimeout(function() {
                jssor_slider = new $JssorSlider$("slider", options)
                // console.log('jssor_slider', jssor_slider)
                that.scaleSlider()
                $('#slider').find('.jssor-slides a').fancybox()
                $(window).bind("load", that.scaleSlider())
                $(window).bind("resize", that.scaleSlider())
                $(window).bind("orientationchange", that.scaleSlider())
              }, 30)
            })
            .catch(function (error) {
              console.log('axios error', error)
            })
            // newsList = [
            //   {id: 1, title: '测试新闻1', date: 0},
            //   {id: 2, title: '测试新闻2', date: 0},
            //   {id: 3, title: '测试新闻3', date: 0},
            //   {id: 4, title: '测试新闻4', date: 0},
            //   {id: 5, title: '测试新闻5', date: 0},
            //   {id: 6, title: '测试新闻6', date: 0},
            //   {id: 7, title: '测试新闻7', date: 0},
            // ]
          } else {
            newsList.forEach(function(news) {
              news.displayDate = that.formatTimestamp(news.date)
            })
            that.newsList = newsList

            var notifications = resp.data.data.noticeList.slice(0, 4)
            // if (notifications.length === 0) {
            //   notifications = [
            //     {id: 1, title: '测试通知1', date: 0},
            //     {id: 2, title: '测试通知2', date: 0},
            //     {id: 3, title: '测试通知3', date: 0},
            //     {id: 4, title: '测试通知4', date: 0},
            //   ]
            // }
            notifications.forEach(function(notification) {
              notification.displayDate = that.formatTimestamp(notification.date)
            })
            that.notifications = notifications

            var newsPictureList = []
            resp.data.data.newsPictureList.forEach(function(pic) {
              newsPictureList.push(that.$UPLOAD_PREFIX + pic)
            })
            // if (newsPictureList.length === 0) {
            //   newsPictureList = [
            //     'http://via.placeholder.com/700x300',
            //     'http://via.placeholder.com/700x300/2B628B/333',
            //     'http://via.placeholder.com/700x300/00aba9/666'
            //   ]
            // }
            that.newsPictureList = newsPictureList
            // console.log('pic', that.newsPictureList)

            var selectedUserList = []
            resp.data.data.selectedUserList.forEach(function(pic) {
              selectedUserList.push(that.$UPLOAD_PREFIX + pic)
            })
            // if (selectedUserList.length === 0) {
            //   selectedUserList = [
            //     'http://via.placeholder.com/600x450',
            //     'http://via.placeholder.com/600x450/2B628B/333',
            //     'http://via.placeholder.com/600x450/00aba9/333',
            //     'http://via.placeholder.com/600x450/6A023E/333',
            //     'http://via.placeholder.com/600x450/8161AB/333',
            //     'http://via.placeholder.com/600x450/C13919/333',
            //     'http://via.placeholder.com/600x450/8FA848/666'
            //   ]
            // }
            that.selectedUserList = selectedUserList
            // console.log('seller', that.selectedUserList)

            window.setTimeout(function() {
              jssor_slider = new $JssorSlider$("slider", options)
              // console.log('jssor_slider', jssor_slider)

              that.scaleSlider()
              $('#slider').find('.jssor-slides a').fancybox()
              $(window).bind("load", that.scaleSlider())
              $(window).bind("resize", that.scaleSlider())
              $(window).bind("orientationchange", that.scaleSlider())
            }, 30)
          }          
        })
        .catch(function (error) {
          console.log('axios error', error)
        })
      
      this.govWebsite = info.refUrl
      this.$emit('updateInfo', info)
    },
    openSellerLogin: function () {
      window.open('https://app.nongxiao123.com', '_blank')
    },
    openGovLogin: function () {
      window.open('https://gov.nongxiao123.com', '_blank')
    },
    openGovWebsite: function () {
      window.open(govWebsite, '_blank')
    },
    goToNews: function (id, event) {
      this.$router.push({
        name: 'News',
        params: {
          id: id
        }})
      
      event.preventDefault()
    },
    scaleSlider: function () {
      // console.log('scaleSlider')
      var containerElement = jssor_slider.$Elmt.parentNode;
      var containerWidth = containerElement.clientWidth;

      if (containerWidth) {
        var expectedWidth = Math.min(containerWidth, containerWidth) - 30;
        // var expectedWidth = Math.min(MAX_WIDTH || containerWidth, containerWidth);
        jssor_slider.$ScaleWidth(expectedWidth);
      }
      else {
        window.setTimeout(scaleSlider, 30);
      }
    },
    scrollTo(refName, event) {
      var element = this.$refs[refName]
      var top = element.offsetTop

      window.scrollTo(0, top)

      event.preventDefault()
    },
    getLocationUrl: function () {
      var info = this.info
      var url = '?'

      if (info.province) {
        url += 'province=' + info.province + '&'
      }
      if (info.city) {
        url += 'city=' + info.city + '&'
      }
      if (info.town) {
        url += 'town=' + info.town
      }

      return url
    },
    formatTimestamp: function (timestamp) {
      var a = new Date(timestamp)
      var year = a.getFullYear()
      var month = a.getMonth() + 1
      var date = a.getDate()

      return year + '-' + (parseInt(month) < 10 ? '0' + month : month) + '-' + date
    }
  },
  mounted() {
    var that = this
    this.init()
    this.getInfo(this.url)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomePage.vue